module.exports = __webpack_public_path__ + "img/logo-act.19bf793b.png";